import React from 'react';

import ClockIcon from 'icons/clock.svg';
import HhqLogo from 'icons/hhq.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import ProfilePhotoDisplay from 'components/application/ProfilePhotoDisplay';
import TableCell from 'components/application/TableCell';

import { asFormattedDateTime } from 'components/helpers/dates';

export default function TrainingEventRow({
  isNadminInitiated,
  personnelEvent,
  userInitials,
  userPhotoPath,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const { createdAt, description } = personnelEvent;

  return (
    <tr>
      <TableCell isFixedHeight={false} style={{ verticalAlign: 'top' }}>
        <ClockIcon
          className='tw-mr-3 tw-inline-block [&_path]:tw-fill-grey-500'
          height={20}
          width={20}
        />
        <span className='tw-text-m tw-text-grey-900'>
          {asFormattedDateTime({ date: createdAt })}
        </span>
      </TableCell>
      <TableCell isFixedHeight={false} style={{ verticalAlign: 'top' }}>
        <div className='tw-mr-2 tw-self-start'>
          {userInitials ?
            userInitials === 'API' ?
              <div className='tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-mint-050'>
                <span className='tw-text-sm tw-flex tw-items-center tw-justify-center tw-align-middle tw-font-semibold tw-uppercase tw-text-mint-700'>
                  {i18nTShared('api')}
                </span>
              </div>
            : <ProfilePhotoDisplay
                componentSize='sm'
                photoUrl={userPhotoPath}
                profileInitials={userInitials}
              />

          : <HhqLogo />}
        </div>
        <div className='tw-flex tw-flex-wrap tw-items-center tw-gap-2'>
          <span className='tw-text-m'>{description}</span>
          {isNadminInitiated && (
            <span className='tw-text-sm tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-mint-050 tw-px-2 tw-py-0.5 tw-font-semibold tw-text-mint-700'>
              HandsHQ
            </span>
          )}
        </div>
      </TableCell>
    </tr>
  );
}

TrainingEventRow.propTypes = {
  isNadminInitiated: PropTypes.bool,
  personnelEvent: PropTypes.object.isRequired,
  userInitials: PropTypes.string,
  userPhotoPath: PropTypes.string,
};
